module.exports = __webpack_public_path__ + "img/logo.4cefeae3.svg";